import moment from "moment";
import React, { useEffect, useState } from "react";
import { ButtonView, Text } from "./ListCardMyGamesHome.styled";
import { getFile } from "../../services/FileManager";
import imgOtherMySpace from "../../assets/image-not-available.png";

const ListCardMyGamesHome = ({
  loadingMyGames,
  errorMyGames,
  myGame,
  goToDetail,
}) => {
  const [previewImage, setPreviewImage] = useState(imgOtherMySpace);

  useEffect(() => {
    if (myGame.coverImage) {
      getFile(myGame.coverImage).then((response) => {
        if (response && response.type !== "archivo-noexistente/json") {
          setPreviewImage(URL.createObjectURL(response));
        }
      });
    } else {
      setPreviewImage(imgOtherMySpace);
    }
  }, [myGame.coverImage]);
  return (
    <>
      {!loadingMyGames && !errorMyGames && (
        <>
          <img src={previewImage} className="img" alt="coverImage" />
          <Text>
            <div className="label1">{myGame.name}</div>
            <div className="label2">{myGame.description}</div>
            <div>
              <span className="label3">Category: </span>
              <span className="label4">{myGame.topic}</span>
            </div>
            <div>
              <span className="label3">Created: </span>
              <span className="label4">
                {moment(myGame.startDate).format("ddd,MMM DD")} |{" "}
                {new Date(myGame.startDate).toLocaleTimeString("en-US", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
                {/* {data.startDate} */}
              </span>
            </div>
          </Text>
          <div style={{ display: "flex", justifyContent: "right" }}>
            <ButtonView onClick={() => goToDetail(myGame)}>
              <span className="button">
                Start Test
              </span>
            </ButtonView>
          </div>
        </>
      )}
    </>
  );
};

export default ListCardMyGamesHome;
